import React, { useEffect } from "react"
import Bugsnag from "@bugsnag/js"
import BugsnagPluginReact from "@bugsnag/plugin-react"
import { getStaticFeatures } from "../hooks/use-feature"

let isReactPage = false

Bugsnag.start({
  apiKey: "1aa833b706e00eed1420f23cc825c90b",
  plugins: [new BugsnagPluginReact()],

  appVersion: process.env.CIRCLE_SHA1,
  releaseStage: process.env.NODE_ENV,
  enabledReleaseStages: ["production", "staging"],
  onError: event => {
    if (!isReactPage) {
      return false
    }

    const error = event.errors[0]

    if (window.analytics) {
      const user = window.app.user

      window.analytics.track("error", {
        path: window.location.pathname.replace(/\d+/g, ":id"),
        context: event.context,
        user_id: user?.id,
        account_id: user?.account_id,
        class_name: error.errorClass
      })
    }

    if (error.errorMessage) {
      const property = error.errorMessage.match(
        /read\sproperty\s'(\w+)'\sof/
      )?.[1]

      if (property) {
        event.groupingHash = `property-access:v1-${property}`
      }
    }

    if (window.FS && window.FS.getCurrentSessionURL) {
      const url = window.FS.getCurrentSessionURL(true)
      event.addMetadata("fullstory", {
        enabled: !!url,
        url
      })
    }

    // Attaches all "static" features (loaded with Frontend::Features module)
    // They'll have their own tab in bugsnag error report
    const features = getStaticFeatures()
    if (features.length > 0) {
      event.addMetadata(
        "features",
        features.reduce((acc, feat) => ({ ...acc, [feat]: true }), {})
      )
    }
  }
})

const ErrorBoundary = Bugsnag.getPlugin("react").createErrorBoundary(React)

function BugsnagComponent({ children }) {
  isReactPage = true

  useEffect(() => {
    if (!window.app) {
      return
    }
    const user = window.app.user
    Bugsnag.setUser(user?.id, user?.email)
    Bugsnag.addMetadata("account", { id: user?.account_id })
  }, [])

  return <ErrorBoundary>{children}</ErrorBoundary>
}

export default BugsnagComponent
